import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    reasons: [],
    fetching: true
  },
  mutations: {
    setReasons (state, reasons) {
      state.reasons = reasons
    }
  },
  actions: {
    fetch ({ state, commit }) {
      state.fetching = true

      apiService.getFormsSosListReasons()
        .then(response => {
          commit('setReasons', response.data.reasons)

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список доступных причин обращений по кнопке SOS.'
          })
        })
    }
  },
  getters: {
    titles: state => {
      return state.reasons.map((reason) => reason.title)
    },
    isReasonCommentRequired: state => reasonTitle => {
      const reason = state.reasons.find((reason) => reason.title === reasonTitle)
      if (reason) {
        return reason.required_fill_comment
      }

      return false
    }
  }
}
